<template>
  <div :class="_.page">
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      title: {
        type: String,
        default: '',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },

    watch: {
      title: {
        immediate: true,
        handler() {
          document.title = this.title
        },
      },
      // UI 要求，不要 loading
      // loading: {
      //   immediate: true,
      //   handler() {
      //     if (this.loading) {
      //       this._loading = Toast.loading({
      //         duration: 0,
      //       })
      //     } else {
      //       this._loading?.clear()
      //     }
      //   },
      // },
    },

    deactivated() {
      this.$tv.resetScrollEl()
    },
  })
</script>

<style lang="scss" module>
  .page {
    min-height: 100vh;
    box-sizing: border-box;
  }
</style>
